import tinycolor from 'tinycolor2';

const baseConfig = {
  appName: 'MovementX',
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  logoPath: '/images/logo-180px.png',
  marketingSiteUrl: 'https://movement-x.com',
  colors: {
    primary: '#0BA9F5',
    secondary: '#FF6700',
    // info: tinycolor('#0BA9F5').lighten(40).toHexString(),
    info: '#9F7AEA',
    success: '#60D39C',
    error: '#f44336',
    warning: '#FFE66D',
    dark: 'rgb(30,30,30)',
    muted: 'rgb(128, 128, 128)',
    // background: '#F9F9F9',
    // More brand colors
    deepTeal: '#164A50',
    teal: '#21A8A8',
    lightTeal: '#9AD2D8',
    goldSand: '#EDBB60',
    lightOrange: '#F19257',
    // Other colors???
    background: '#F9F9F9',
    purple: '#9F7AEA',
    light: '#e1e1e1',
    light2: '#E3E3E3',
    silver: '#E9ECF2',
    text: '#3D414E',
    secondaryText: '#EBFBFA',
    lightText: '#646E8F',
    blackText: '#1D1E25',
    gray: '#808D9E',
    orange: '#FF6700',
    blue: '#0BA9F5',
    white: '#FFFFFF',
    border: '#D7DEE1',
    grayLight: '#6F767E',
  },
  styles: {
    defaultBoxShadow: '0px 4px 24px 0px #0000001A',
    defaultRadius: '0.75rem',
    defaultBorder: '0.5px solid #D7DEE1',
  },
  brandFont: 'Montserrat',
  secondFont: 'Inter',
  companyPhone: '(202) 681-1474',
  supportEmail: 'support@movement-x.com',
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  turnstilePublicKey: process.env.REACT_APP_TURNSTILE_PUBLIC_KEY,
  mapBoxPublicApiKey: process.env.REACT_APP_MAPBOX_PUBLIC_API_KEY,
  useSentry: !!process.env.REACT_APP_SENTRY_DSN,
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  mixpanelToken: process.env.REACT_APP_MIXPANEL_PUBLIC_TOKEN,
  staxPublicToken: process.env?.REACT_APP_STAX_PUBLIC_TOKEN || null,
  inactivityLogoutDisabled: (
    !!process.env.REACT_APP_DISABLE_INACTIVITY_LOGOUT
    || false
  ),
  isStaging: /movementx\.ai/.test(process.env.REACT_APP_API_URL),
};

const config = () => baseConfig;

export default config;
